import $ from 'jquery';

export default class Header {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.$header = $('.site-header');
    this.$adminBar = $('#wpadminbar');
    this.$hero = $('.hero').first();
    this.$scrollPos = 0;
    this.addEvents();
  }

  addEvents() {
    this.$window.on('scroll', this.scrolling.bind(this));
  }

  getScrollPosition() {
    return window.pageYOffset !== undefined ? window.pageYOffset : window.scrollTop;
  }

  scrolling() {
    // Get current scroll position.
    let st = this.getScrollPosition();
    let showScrollWhen = this.$hero.length ? this.$hero.outerHeight() : 100;
    if (window.ajax_object.theme === 'drager') {
      showScrollWhen = 100;
    }

    // If we are hero height pixels from top. Make menu fixed.
    if (st > showScrollWhen && !this.$body.hasClass('is-fixed')) {
      this.$body.addClass('is-fixed');
    } else if (st <= showScrollWhen && this.$body.hasClass('is-fixed')) {
      // Make menu absolute.
      this.$body.removeClass('is-fixed');
    }

    // Show/hide menu depending on scroll direction.
    if (this.$scrollPos > st && !this.$header.hasClass('show')) {
      // Scrolling up, show menu.
      this.$header.addClass('show');
    } else if (this.$scrollPos <= st) {
      // Scrolling down, hide menu.
      this.$header.removeClass('show');
    }

    // Set scroll position
    this.$scrollPos = st;
  }
}
